// extracted by mini-css-extract-plugin
export default {"title":"Header_title__G1+K6"};